<template>
  <div class="alert alert-primary mt-0 mb-0" role="alert">
    <span class="fw-bold">Low timeframes, High Frequency & Latency</span>
    <br>
    Please be aware that SIGNUM takes <b>a few seconds</b> to execute your trades. Take care when trading on <b>fast charts</b> or when doing <b>high frequency trading</b>. Test it with small amounts first and check if the latency works for what you're trying to achieve.
    <br>
    <br>
    <a href="https://www.youtube.com/watch?v=gnvD_VkwxWQ" target="_blank"><span class="fw-bold">Learn about the risks of trading on lower timeframes</span> <span class="fab fa-youtube" data-fa-transform="right-0 down-0"></span></a>
    <br>
    <br>
    SIGNUM is made for retail investors and is NOT meant for fast or high frequency trading!
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>

</style>